module.exports = __webpack_public_path__ + "img/fa-solid-900.56292bd5.svg";